import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { UserModel } from '@core/api/model/userModel';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { OrderModel, TrailerModel, UserService } from '@core/api';
import { OrderService } from '@accounts/user/services/order.service';
import { OrderTimeService } from '@core/components/services/order-time.service';
import { ConfirmationDialogService } from '@ui/confirmation-dialog/confirmation-dialog.service';
import { Observable, Subscription } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';

export interface IDialogData {
  order: OrderModel;
}

@Component({
  selector: 'rental-detail',
  templateUrl: './rental-detail.component.html',
  styleUrls: ['./rental-detail.component.scss']
})
export class RentalDetailComponent implements OnDestroy {

  loading = false;
  inRentOrders$: Subscription;
  accepted: boolean;
  user: UserModel;
  order: OrderModel;
  trailer: TrailerModel
  constructor(
    private i18n: I18n,
    private orderService: OrderService,
    private orderServices: OrderTimeService,
    private confirmationDialogService: ConfirmationDialogService,
    private router: Router

  ) {
    this.loading = true;
    const params = new HttpParams();
    this.inRentOrders$ = orderService.getInrentOrders(params)
      .subscribe(orders => {

        if (!!orders && orders.length > 0) {


          this.order = orders[0];
          this.trailer = this.order.trailer;
        }
        this.loading = false;
      })

  }

  get hasOrder(): boolean {
    return !!this.order;
  }
  ngOnDestroy(): void {
    this.inRentOrders$.unsubscribe();
  }

  get perLabel() {
    return this.orderServices.getStringOrderTime(this.order.tariff_type, this.order.rent_hours);
  }

  get returnAddress(): string {
    return this.order.returnGasStation ? this.order.returnGasStation.address : this.order.gasStation.address;
  }

get isPaidTimeOver(): boolean{
  return this.orderService.isPaidTimeOver(this.order);
}

  get timeLeft(): string {
    return this.orderService.getTimeLeft(this.order);
  }

  close() {
    this.router.navigate(['../cabinet/new']);
  }

  return() {
    return this.confirmationDialogService.confirm({
      confirmBtnText: this.i18n('Закрыть'),
      message: this.i18n('Для возврата прицепа обратитесь к оператору'),
      title: this.i18n('Возврат прицепа')
    });
  }

  openJivoChat() {
    if (window['jivo_api']) {
      window['jivo_api'].open();
    }
  }
}
